var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack, Typography, } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { FallbackComponent } from '../fallback';
import { ErrorMessageBox } from '../messageBox';
var StyledDialog = styled(Dialog)(function () { return ({
    '& .MuiPaper-root': {
        width: '100%',
        maxWidth: 600,
        minWidth: 500,
    },
}); });
var StyledButton = styled(Button)({
    minWidth: 'fit-content',
});
var StyledDialogIcon = styled(FontAwesomeIcon)(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: theme.typography.pxToRem(24),
        color: theme.palette.warning.main,
    });
});
var StyledTitle = styled(Typography)(function (_a) {
    var theme = _a.theme;
    return ({
        color: theme.palette.primary.main,
        fontWeight: 'bold',
        fontSize: theme.typography.h1.fontSize,
        lineHeight: 1.5,
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        overflowWrap: 'anywhere',
        wordBreak: 'break-word',
    });
});
export var ConfirmDialog = function (props) {
    var _a, _b, _c, _d;
    var t = useTranslation().t;
    var isOnlyShowCancel = !props.onSkipSaveConfirm && !props.onConfirm;
    // Backdrop/Escape share onClose with the cancel button by default; when disabled, dismissal is a
    // no-op so the user must choose an explicit action (used by warnings where dismiss != a decision).
    var handleDialogClose = function () {
        if (props.disableBackdropClose)
            return;
        props.onClose();
    };
    return (_jsxs(StyledDialog, __assign({ open: props.open, onClose: handleDialogClose }, { children: [props.title && (_jsx(DialogTitle, { children: _jsxs(Stack, __assign({ direction: "row", spacing: 2, alignItems: "center", sx: { minWidth: 0 } }, { children: [_jsx(StyledDialogIcon, { icon: faTriangleExclamation }), _jsx(StyledTitle, __assign({ title: props.title }, { children: props.title }))] })) })), _jsx(DialogContent, __assign({ sx: { maxWidth: '36rem' } }, { children: _jsxs(FallbackComponent, __assign({ requesting: props.loading, overlay: true }, { children: [_jsx(ErrorMessageBox, { errors: (_a = props.errors) !== null && _a !== void 0 ? _a : [] }), _jsx(DialogContentText, __assign({ component: "div" }, { children: props.message }))] })) })), _jsxs(DialogActions, __assign({ sx: { justifyContent: isOnlyShowCancel ? 'flex-end' : 'space-between' } }, { children: [_jsx(StyledButton, __assign({ variant: "outlined", onClick: props.onClose }, { children: t("action.".concat((_b = props.cancelButtonText) !== null && _b !== void 0 ? _b : 'cancel')) })), !isOnlyShowCancel && (_jsxs(Stack, __assign({ direction: "row", spacing: 2 }, { children: [_jsx(Box, {}), props.onSkipSaveConfirm && (_jsx(StyledButton, __assign({ variant: "outlined", onClick: props.onSkipSaveConfirm }, { children: t("action.".concat((_c = props.skipSaveButtonText) !== null && _c !== void 0 ? _c : 'skipSave')) }))), props.onConfirm && (_jsx(StyledButton, __assign({ variant: "contained", onClick: props.onConfirm }, { children: t("action.".concat((_d = props.confirmButtonText) !== null && _d !== void 0 ? _d : 'yes')) })))] })))] }))] })));
};
